// Normalizes a US phone number to E.164 format (+12223334444).
// Handles inputs like: 2083128550, 12083128550, (208) 312-8550, 208-312-8550, +12083128550
export function normalizePhoneNumber(raw) {
  // Strip everything except digits
  const digits = raw.replace(/\D/g, "");

  if (digits.length === 10) {
    // 2083128550 → +12083128550
    return `+1${digits}`;
  }

  if (digits.length === 11 && digits.startsWith("1")) {
    // 12083128550 → +12083128550
    return `+${digits}`;
  }

  // Already has country code or unrecognized format — return as-is with + prefix
  return raw.startsWith("+") ? raw : `+${digits}`;
}
